"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInferredUserRole = void 0;

var getInferredUserRole = function getInferredUserRole(state) {
  return state.identityRepository.get('inferredUserRole');
};

exports.getInferredUserRole = getInferredUserRole;